import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import { typography } from '@resiliatech/birdsong'

export const FunderGoalPageContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0 24px 60px 24px;
  width: 100%;
`

export const GoalPageHeader = styled(Typography)`
  ${typography.up3.regularSerif}
  line-height: 120%;
  padding-bottom: 6px;
  font-size: 34px;
`
export const GoalPageSubHeader = styled(Typography)`
  ${typography.baseline.regularSans}
  line-height: 150%;
`
